export default {
  surveyData: {},
  success_submit_survey: "",
  err_survey: "",
  available_surveys: false,
};
